import { render, staticRenderFns } from "./decorationPage.vue?vue&type=template&id=1283bacf&scoped=true"
import script from "./decorationPage.vue?vue&type=script&lang=js"
export * from "./decorationPage.vue?vue&type=script&lang=js"
import style0 from "./decorationPage.vue?vue&type=style&index=0&id=1283bacf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1283bacf",
  null
  
)

component.options.__file = "decorationPage.vue"
export default component.exports